<lib-ikp-top-page
  [title]="'global.registration.invite.title'"
  [subtitle]="'global.registration.invite.subTitle'"
  [showGoBackLink]="false"
  [dataTest]="'accountRegistration-header-inviteTopPageTitle'"
/>
<div class="profile-creation d-flex flex-column gap-4">
  <mwe-basic-card cardTitle="global.registration.invite.cardTitle" cardClass="ikp-basic-card-override" [hasBackground]="true">
    <div>
      <p>
        Bitte beachten Sie, dass die von Ihnen eingegebene E-Mail-Adresse vom Kunden für den zukünftigen Login im Portal verwendet werden
        muss.
      </p>
      <form [formGroup]="inviteForm" class="needs-validation" data-test="einladen-form-createInvite">
        <div class="form-floating mb-3">
          <input
            formControlName="email"
            type="email"
            class="form-control"
            id="floatingEmail"
            placeholder="E-Mail"
            aria-label="Email"
            [ngClass]="{ 'is-invalid': isEmailInvalid() }"
            data-test="einladen-input-inputEmail'"
          />
          <label for="floatingEmail">E-Mail</label>
          <div class="invalid-feedback">{{ getFormError('email') | translate }}</div>
        </div>
      </form>
    </div>
  </mwe-basic-card>
  @if (isInviteError()) {
    <mwe-inline-notification
      type="danger"
      titleKey="global.registration.invite.errorNotifcationTitle"
      messageKey="global.registration.invite.errorNotifcationMessage"
      ctaLabelKey="global.registration.invite.errorNotificationCTA"
      [showCloseButton]="true"
      (onCloseClick)="isInviteError.set(false)"
      (onCTAClick)="onInfoMessageCTAClicked()"
    />
  }
</div>
